/**
 * Optionen für Industriebranchen
 */
export const industryOptions = [
  { value: "Automobilindustrie", label: "Automobilindustrie" },
  { value: "Agenturen", label: "Agenturen" },
  { value: "Baugewerbe & Bauwirtschaft", label: "Baugewerbe & Bauwirtschaft" },
  { value: "Beauty-, Kosmetika- und Frisörgewerbe", label: "Beauty-, Kosmetika- und Frisörgewerbe" },
  { value: "Bildung, Erziehung & Unterricht", label: "Bildung, Erziehung & Unterricht" },
  { value: "Biotechnologie & Chemietechnik", label: "Biotechnologie & Chemietechnik" },
  { value: "Dienstleistungsbranche (Finanzen & Versicherungen)", label: "Dienstleistungsbranche (Finanzen & Versicherungen)" },
  { value: "Dienstleistungsbranche (Sonstige)", label: "Dienstleistungsbranche (Sonstige)" },
  { value: "Energieversorgung & Energiewirtschaft", label: "Energieversorgung & Energiewirtschaft" },
  { value: "Gesundheitswesen", label: "Gesundheitswesen" },
  { value: "Handel / E-Commerce", label: "Handel / E-Commerce" },
  { value: "Hotel- und Gastgewerbe", label: "Hotel- und Gastgewerbe" },
  { value: "Immobilien-, Grundstücks- und Wohnungswesen", label: "Immobilien-, Grundstücks- und Wohnungswesen" },
  { value: "IT-Branche", label: "IT-Branche" },
  { value: "Kunst, Unterhaltung und Erholung", label: "Kunst, Unterhaltung und Erholung" },
  { value: "Land- und Forstwirtschaft, Fischerei", label: "Land- und Forstwirtschaft, Fischerei" },
  { value: "Lebensmittelindustrie", label: "Lebensmittelindustrie" },
  { value: "Logistik, Lagerei & Verkehrswirtschaft", label: "Logistik, Lagerei & Verkehrswirtschaft" },
  { value: "Luft- und Raumfahrt", label: "Luft- und Raumfahrt" },
  { value: "Medien / Publisher", label: "Medien / Publisher" },
  { value: "Medizintechnik", label: "Medizintechnik" },
  { value: "Montanindustrie & Bergbau", label: "Montanindustrie & Bergbau" },
  { value: "Öffentliche Verwaltung", label: "Öffentliche Verwaltung" },
  { value: "Pharmabranche", label: "Pharmabranche" },
  { value: "Schiffbau und Meerestechnik", label: "Schiffbau und Meerestechnik" },
  { value: "Spielzeugbranche", label: "Spielzeugbranche" },
  { value: "Sonstige", label: "Sonstige" },
  { value: "Telekommunikationsbranche", label: "Telekommunikationsbranche" },
  { value: "Textil- und Bekleidungsbranche", label: "Textil- und Bekleidungsbranche" },
  { value: "Wasser, Abwasser & Entsorgung", label: "Wasser, Abwasser & Entsorgung" },
];

/**
 * Optionen für Unternehmensgrößen
 */
export const companySizeOptions = [
  { value: "1-9 Mitarbeitende", label: "1-9 Mitarbeitende" },
  { value: "10-49 Mitarbeitende", label: "10-49 Mitarbeitende" },
  { value: "50-99 Mitarbeitende", label: "50-99 Mitarbeitende" },
  { value: "100-249 Mitarbeitende", label: "100-249 Mitarbeitende" },
  { value: "250-499 Mitarbeitende", label: "250-499 Mitarbeitende" },
  { value: "500-999 Mitarbeitende", label: "500-999 Mitarbeitende" },
  { value: "1000-4999 Mitarbeitende", label: "1000-4999 Mitarbeitende" },
  { value: "über 5000 Mitarbeitende", label: "über 5000 Mitarbeitende" }
];
